const seurat = 'nintendoP_Seurat-B';
const seuratSub = 'nintendoP_Seurat-B-sub';
const seuratSub2 = 'nintendoP_Seurat-B-sub2';
const cnFont = 'DFP_GB_Y9_0';
const cnFontLang = 'DFP_GB_Y9_0_langmin';
const twFont = 'DFPT_Y8';
const krFontSub = 'AsiaKSDNR-B-sub';
const krFontLang = 'AsiaKSDNR-B-langmin';
const swZhCn = 'nintendo_udsg-r_org_zh-cn';
const swZhCnExt = 'nintendo_udsg-r_ext_zh-cn';
const swZhTw = 'nintendo_udjxh-db_zh-tw';
const swKoKr = 'nintendo_udsg-r_ko';
const ext = 'ParkExt';

const systemBList = [swZhCn, swZhCnExt, swZhTw, swKoKr, 'system-ui'];

export function fontFamily(lang: string) {
  switch (lang) {
    case 'zh-CN':
      return [ext, seuratSub, cnFont, krFontLang, twFont, krFontSub, seurat, ...systemBList].join(
        ','
      );
    case 'zh-TW':
      return [
        ext,
        seuratSub2,
        twFont,
        cnFontLang,
        krFontLang,
        cnFont,
        krFontSub,
        seurat,
        ...systemBList
      ].join(',');
    case 'ko-KR':
      return [ext, seuratSub, krFontSub, cnFontLang, cnFont, twFont, seurat, ...systemBList].join(
        ','
      );
    case 'ja-JP':
    case 'de-DE':
    case 'en-GB':
    case 'en-US':
    case 'es-ES':
    case 'es-US':
    case 'fr-CA':
    case 'fr-FR':
    case 'it-IT':
    case 'nl-NL':
    case 'ru-RU':
    default:
      return [ext, seurat, cnFontLang, krFontLang, cnFont, twFont, krFontSub, ...systemBList].join(
        ','
      );
  }
}
